import React, { Component } from 'react'

import Typed from 'typed.js'

import Progress from 'react-progress'
import { Link } from 'react-scroll'

import styled from 'styled-components'
import NavButton from '../button/navButton'

import {
  blink,
  enterLeft,
  enterRight,
  enterUpLeft,
  enterUpRight,
  progressWidth
} from './animations'

const SlideContainer = styled.div`
  transition: all ease-in-out 1s;
`

const AnimatedImage = styled.img`
  animation: ${props =>
    `${props.orientation === 'right' ? enterRight : enterLeft} 1s linear`};
`

const AnimatedTitle = styled.h1`
  animation: ${props =>
    `${props.orientation === 'right' ? enterUpRight : enterUpLeft} 1s linear`};
`

const StyledPrincipalTitle = styled.h1`
  color: #54666f;
  margin: 0;
  margin-bottom: 10px;
`

const StyledPrincipalSubTitle = styled.h2`
  font-size: 1.25rem;
  opacity: 0.6;
  letter-spacing: 3.6px;
  color: #3c4252;
  margin: 0;
  margin-bottom: 30px;
`

const StyledMobileSubTitle = styled.h6`
  opacity: 0.6;
  letter-spacing: 2.8px;
  color: #3c4252;
  margin: 0;
`

const CustomBold = styled.span`
  font-weight: 600;
  color: #3c4252;
`

const StyledStaticText = styled.div`
  display: inline;
  color: #54666f;
  font-weight: 300;
`

const TextTypedWrapper = styled.div`
  display: ${props => (props.forceBackSpace === true ? 'none' : 'inline')};
  color: #54666f;
  font-weight: 300;
  .typed-cursor {
    opacity: 1;
    animation: ${blink} 1s linear infinite;
  }
`

const ForcedText = styled.div`
  display: ${props => (props.forceBackSpace !== true ? 'none' : 'inline')};
  color: #54666f;
  font-weight: 300;
`

const LinkArrowContainer = styled(Link)`
  position: absolute;
  bottom: 0;
  z-index: 4;
  left: 0;
  right: 0;
  text-align: center;
  padding: 2rem;
`

const Arrow = styled.i`
  font-size: 2rem;
  color: #434659;
  cursor: pointer;
`

const MobileImgContainer = styled.div``
const MobileContainer = styled.div`
  padding-top: 5rem;
`

const MobileTitleContainer = styled.div`
  overflow: hidden;
  transition: height linear 0.5s;
`

const StyledProgress = styled.div`
  &.progress {
    top: auto !important;
    bottom: 0;
    position: absolute !important;
    width: 100%;
    height: 5px;
    background: transparent;
  }
`
const StyledProgressBar = styled.div`
  &.progress-bar {
    background-color: #3c4252;
    height: 5px;
    animation: ${progressWidth} ${props => props.timer}s linear;
    animation-play-state: ${props =>
      props.pause === true ? 'paused' : 'running'};
  }
`

class Slide extends Component {
  state = {
    typeSpeed: 80,
    backSpeed: 80,
    smartBackspace: true,
    backDelay: 3000,
    forceBackSpace: this.props.forceBackSpace,
    completeDestroy: false,
    showedText: this.props.text,
    action: this.props.action
  }

  _initTyped = () => {
    let { changeSlide } = this.props
    let {
      typeSpeed,
      backSpeed,
      smartBackspace,
      backDelay,
      forceBackSpace,
      completeDestroy,
      showedText,
      action
    } = this.state
    const options = {
      strings: [
        `${forceBackSpace === true ? '^0 `' + showedText + '`' : showedText}`,
        ''
      ],
      typeSpeed: typeSpeed,
      backSpeed: backSpeed,
      smartBackspace: smartBackspace,
      backDelay: backDelay,
      onComplete: self => {
        this.setState({ forceBackSpace: false }, () => this.typed.destroy())
      },
      onDestroy: self => {
        let { forceBackSpace, action } = this.state
        if (forceBackSpace === true) {
          this._initTyped()
          return true
        }
        if (!completeDestroy) {
          changeSlide(action)
        }
      },
      onStringTyped: (arrayPos, self) => {
        if (arrayPos === 0) {
          this.setState({ forceBackSpace: false })
        }
      }
    }
    this.typed = new Typed(this.TextReference, options)
  }

  componentDidMount() {
    this._initTyped()
  }

  componentWillReceiveProps(nextProps) {
    let { text, name, forceBackSpace, isMobile, action, pause } = nextProps
    let { pause: isPaused } = this.props

    if (pause !== isPaused) {
      this.typed.toggle()
      return true
    }

    if (isMobile === true) {
      this.setState({ action: action }, () => this.typed.destroy())
      return true
    }

    if (name !== this.props.name) {
      this.setState(
        {
          showedText: text,
          forceBackSpace: forceBackSpace,
          backDelay: 3000,
          action: action
        },
        () => this._initTyped()
      )
    } else {
      if (forceBackSpace === true) {
        this.typed.destroy()
      }
    }
  }

  componentWillUnmount() {
    this.typed.destroy()
  }

  render() {
    let {
      principalImage,
      needsUpdate,
      backSpace,
      waiter,
      stepProgress,
      forceBackSpace
    } = this.state
    let {
      orientation,
      text,
      name,
      changeSlide,
      main,
      overlay,
      mainStyle,
      overlayStyle,
      mobile,
      link,
      timer,
      pause,
      btnText
    } = this.props
    return (
      <SlideContainer className="container-fluid">
        <div className="row h-100">
          <AnimatedImage
            key={`image-${name}-main`}
            src={main}
            orientation={orientation}
            className={`d-none d-lg-block img-fluid`}
            style={mainStyle}
          />
          <AnimatedImage
            key={`image-${name}-overlay`}
            orientation={orientation}
            className={`d-none d-lg-block img-fluid`}
            style={overlayStyle}
            src={overlay}
          />
          <MobileContainer className="col-12 d-lg-none d-xl-none d-md-block">
            <MobileTitleContainer>
              <AnimatedTitle
                orientation={orientation}
                key={`title-${name}-mobile`}
                className={`text-center mt-1`}
              >
                <CustomBold>Elige </CustomBold>
                <StyledStaticText>{text}</StyledStaticText>
              </AnimatedTitle>
            </MobileTitleContainer>
            <StyledMobileSubTitle
              key={`subtitle-${name}-mobile`}
              className={`mt-0 text-center`}
            >
              {name}
            </StyledMobileSubTitle>
            <MobileImgContainer className="d-flex align-items-center">
              <AnimatedImage
                key={`image-${name}-mobile`}
                src={mobile}
                orientation={orientation}
                className={`img-fluid mx-auto`}
              />
            </MobileImgContainer>
            <div className="text-center text-lg-left">
              <NavButton
                className="d-block"
                onClick={() =>
                  this.setState({ completeDestroy: true }, () =>
                    this.typed.destroy()
                  )
                }
                to={link}
                title={btnText}
              />
            </div>
          </MobileContainer>
          <div className="col-12 col-lg-5 offset-lg-7 align-items-center d-none d-lg-flex">
            <div>
              <StyledPrincipalTitle className="text-left">
                {forceBackSpace === true ? (
                  <CustomBold>Elige</CustomBold>
                ) : (
                  <CustomBold>Elige </CustomBold>
                )}
                <TextTypedWrapper forceBackSpace={forceBackSpace}>
                  <span
                    ref={TextReference => {
                      this.TextReference = TextReference
                    }}
                  />
                </TextTypedWrapper>
                {forceBackSpace === true && (
                  <ForcedText forceBackSpace={forceBackSpace}>
                    {' '}
                    {text}
                  </ForcedText>
                )}
              </StyledPrincipalTitle>
              <StyledPrincipalSubTitle className={`text-left`}>
                {name}
              </StyledPrincipalSubTitle>
              <div className="text-center text-lg-left">
                <NavButton
                  className="d-inline-block"
                  onClick={() =>
                    this.setState({ completeDestroy: true }, () =>
                      this.typed.destroy()
                    )
                  }
                  to={link}
                  title={btnText}
                />
              </div>
            </div>
          </div>
          <LinkArrowContainer
            className="d-none d-lg-block"
            to="innovation"
            spy={true}
            smooth={true}
            duration={1000}
          >
            <Arrow className={'icon-arrow-down'} />
          </LinkArrowContainer>
          <StyledProgress
            key={`progress-${name}`}
            className="progress d-none d-lg-block"
          >
            <StyledProgressBar
              pause={pause}
              timer={timer}
              className="progress-bar"
              role="progressbar"
              aria-valuenow="25"
              aria-valuemin="0"
              aria-valuemax="100"
            />
          </StyledProgress>
        </div>
      </SlideContainer>
    )
  }
}

export default Slide



// WEBPACK FOOTER //
// ./src/components/slider/slide.js